import {
  TReceivedInvoiceCondition,
  TSetupConditionProps,
} from '@/context/services/invoice/type';
import { useTranslation } from '@/i18n';
import {
  DatepickerProps,
  FormDatepicker,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export const DueDate: FC<TSetupConditionProps> = memo(({ control, name }) => {
  const { t } = useTranslation();
  const datepickerProps: DatepickerProps = useMemo(
    () => ({
      placeholder: [t('date_gteq_placeholder'), t('date_lteq_placeholder')],
    }),
    [t]
  );
  const labelProps = useMemo(
    () => ({
      text: t('received_invoice_due_date'),
    }),
    [t]
  );

  return (
    <FormDatepicker<TReceivedInvoiceCondition>
      control={control}
      name={name}
      inputId='select-due-date'
      testId='select-due-date'
      datepickerProps={datepickerProps}
      label={labelProps}
    />
  );
});
DueDate.displayName = 'DueDate';
